// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.midi-browser.dialog {
    z-index: 1;
    width: 680px;
}

.midi-browser .search .note:hover {
    background-color: var(--black-65);
}

.midi-browser .search .icon {
    position: absolute;
    font-size: 22px;
    color: var(--black-45);
    user-select: none; 
}

.midi-browser .search .icon.search {
    left: 10px;
}

.midi-browser .search .icon.reset {
    left: 294px;
}

.midi-browser .search .icon.reset:hover {
    color: var(--black-80);
}

.midi-browser .searchbox {
    margin-top: 4px;
    font-size: 15px;
  
    width: 320px;
    height: 32px;
    /** if missing, caret appears in upper left of searchbox when empty (and focused) */
    padding: 0 5px;
    padding-left: 34px;
    padding-right: 30px;

    color: var(--black-65);
    background-color: var(--black-10);

    border: solid var(--black-15) 1px;
    border-radius: 4px;

    /** prevents default outlining of active input text box */
    outline: none;

    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    overflow: hidden;
}

.midi-name {
    max-width: 360px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.midi-browser .searchbox.empty {
    color: var(--black-35);
    user-select: none; 
}

.midi-browser .searchbox.edit {
    font-style: normal;
    text-overflow: clip;
    overflow: hidden;
    color: var(--black-80);
    background-color: var(--black-20);
    padding: 0 5px;
    padding-left: 34px;
}

.midi-browser .entities {
    width: 100%;
    max-height: 400px;
    height: 400px;

    overflow-y: auto;
}

.midi-browser .entities .noresults {
    color: var(--black-45);
    font-style: italic;
    height: 48px;
    width: 100%;
    font-size: 16px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.midi-browser .entities .entity,
.midi-browser .headers {
    width: 100%;
    height: 26px;

    color: var(--black-65);
    display: flex;
    justify-content: left;
    align-items: center;

    user-select: none; 
}

.midi-browser .entities .entity {
    background-color: var(--black-00);
}

.midi-browser .headers {
    height: 32px;
    background-color: var(--black-10);
}

@keyframes midi-pulse-bg {
    0%, 100% {
        filter: opacity(1.0)
    }
    50% {
        filter: opacity(0.5);
    }
}

.midi-browser .entities .entity.learning {
    animation: midi-pulse-bg 1s ease-in-out infinite;
    background-color: rgba(147, 55, 255, 1);
}

.midi-browser .entities .entity:nth-child(odd):not(.learning) {
    background-color: var(--black-02);
}

.midi-browser .entities .entity:nth-child(odd):not(.learning):hover, 
.midi-browser .entities .entity:hover {
    color: var(--black-80);
    background-color: var(--black-20);
}

.midi-browser .entities .entity .cat,
.midi-browser .headers .header.cat {
    width: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.midi-browser .entities .entity .cat {
    color: var(--black-45);
}

.midi-browser .entities .entity .cat .symbols {
    font-size: 16px;
}

.midi-browser .entities .entity:hover .cat {
    color: var(--black-80);
}

.midi-browser .entities .entity .name,
.midi-browser .headers .header.name {
    font-size: 14px;
    flex-grow: 1;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.midi-browser .entities .entity .note,
.midi-browser .headers .header.note {
    position: relative;
    width: 120px;
    font-size: 12px;
    flex-shrink: 0;

    padding-left: 3px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.midi-browser .entities .entity .note {
    color: var(--black-80);
}

.midi-browser .entities .entity .note.shared:before {
    position: absolute;
    left: 5px;
    content: '🟡';
    font-size: 5px;
}

.midi-browser .entities .entity .actions {
    width: 25px;
    font-size: 18px;
}

.midi-browser > .header {
    width: 320px;
    margin-bottom: 4px;

    font-size: 22px;

    display: flex;
    text-align: center;
    justify-content:space-between;
    align-items: center;
}

.midi-browser > .header > .left {
    display: flex;
    text-align: center;
    justify-content: left;
    align-items: center;
    position: relative;
}

.midi-browser > .header > .right {
    display: flex;
    text-align: center;
    justify-content: right;
    align-items: center;
}

.midi-browser > .header .filter {
    height: 26px;
    width: 100px;
    border-radius: 4px;

    font-size: 13px;
    font-weight: bold;
    letter-spacing: 0;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    padding-left: 2px;

    cursor: pointer;
    user-select: none; 

    color: var(--black-05);
    background-color: var(--black-65);
}

.midi-browser > .header .filter:hover {
    background-color: var(--black-80);
}

.midi-browser > .header .note {
    top: 5px;
    left: 446px;
    border-radius: 5px;
    width: fit-content;
    height: 26px;

    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    color: var(--black_10);
    background-color: var(--black-65);

    display: flex;
    justify-content: left;
    align-items: center;

    padding-left: 5px;
    padding-right: 7px;
    padding-top: 1px;
    margin-left: 10px;
}

.midi-browser > .header .note.disabled {
    background-color: var(--black-25);
    color: var(--black-15);
}

.midi-browser > .header .note::before {
    content: 'music_note';
    font-family: 'Material Symbols Outlined';
    user-select: none;
    font-weight: 500;
    font-size: 14px;

    display: flex;
    justify-content: center;
    align-items: center;

    color: var(--black-00);
}

.midi-browser > .header .note:hover::before {
    content: 'close';
}

.midi-browser > .header .note:hover {
    background-color: var(--black-80);
}

.midi-browser > .headers > .header {
    width: 550px;
}

.midi-browser .headers .header.cat {
    display: flex;
    justify-content: center;
    align-items: center;
}

.midi-browser .headers .header:hover  {
    color: var(--black-90);
}

.midi-browser .headers .header {
    width: 100%;
    height: 100%;
    position: relative;
    left: -8px;
}

.midi-browser .headers .header .order {
    position: relative;
    visibility: hidden;

    left: 0px;

    content: 'close';
    font-family: 'Material Symbols Outlined';
    user-select: none;
    font-weight: 500;
    font-size: 14px;

    display: flex;
    justify-content: center;
    align-items: center;
}

.midi-browser .headers .header.active {
    color: var(--black-80);
}

.midi-browser .headers .header:hover .order {
    visibility:visible;
}

.midi-browser .headers .header.active .order {
    visibility:visible;
}

.midi-browser .headers .header .order.north:before {
    content: 'north';
}

.midi-browser .headers .header .order.south:before {
    content: 'south';
}

.midi-browser .headers .header .symbols {
    font-size: 18px;
}

.midi-browser .headers .header.name {
    font-weight: 500;
    font-size: 14px;
    width: 360px;
    flex-grow: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.midi-browser .headers .header.note {
    font-size: 10px;
    padding-left: 3px;

    display: flex;
    justify-content: center;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/midi.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,eAAe;;IAEf,YAAY;IACZ,YAAY;IACZ,mFAAmF;IACnF,cAAc;IACd,kBAAkB;IAClB,mBAAmB;;IAEnB,sBAAsB;IACtB,iCAAiC;;IAEjC,iCAAiC;IACjC,kBAAkB;;IAElB,yDAAyD;IACzD,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;IACjC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;;IAEb,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;;IAEf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,iCAAiC;AACrC;;AAEA;IACI;QACI;IACJ;IACA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,gDAAgD;IAChD,uCAAuC;AAC3C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,eAAe;IACf,YAAY;;IAEZ,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,cAAc;;IAEd,iBAAiB;;IAEjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,eAAe;;IAEf,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;;IAEjB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;;IAEjB,eAAe;IACf,iBAAiB;;IAEjB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;;IAEZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,iCAAiC;;IAEjC,aAAa;IACb,qBAAqB;IACrB,mBAAmB;;IAEnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;IACxC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;;IAEf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;;IAElB,SAAS;;IAET,gBAAgB;IAChB,wCAAwC;IACxC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;;IAEf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,YAAY;;IAEZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;;IAEjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":[".midi-browser.dialog {\n    z-index: 1;\n    width: 680px;\n}\n\n.midi-browser .search .note:hover {\n    background-color: var(--black-65);\n}\n\n.midi-browser .search .icon {\n    position: absolute;\n    font-size: 22px;\n    color: var(--black-45);\n    user-select: none; \n}\n\n.midi-browser .search .icon.search {\n    left: 10px;\n}\n\n.midi-browser .search .icon.reset {\n    left: 294px;\n}\n\n.midi-browser .search .icon.reset:hover {\n    color: var(--black-80);\n}\n\n.midi-browser .searchbox {\n    margin-top: 4px;\n    font-size: 15px;\n  \n    width: 320px;\n    height: 32px;\n    /** if missing, caret appears in upper left of searchbox when empty (and focused) */\n    padding: 0 5px;\n    padding-left: 34px;\n    padding-right: 30px;\n\n    color: var(--black-65);\n    background-color: var(--black-10);\n\n    border: solid var(--black-15) 1px;\n    border-radius: 4px;\n\n    /** prevents default outlining of active input text box */\n    outline: none;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-align: left;\n    overflow: hidden;\n}\n\n.midi-name {\n    max-width: 360px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.midi-browser .searchbox.empty {\n    color: var(--black-35);\n    user-select: none; \n}\n\n.midi-browser .searchbox.edit {\n    font-style: normal;\n    text-overflow: clip;\n    overflow: hidden;\n    color: var(--black-80);\n    background-color: var(--black-20);\n    padding: 0 5px;\n    padding-left: 34px;\n}\n\n.midi-browser .entities {\n    width: 100%;\n    max-height: 400px;\n    height: 400px;\n\n    overflow-y: auto;\n}\n\n.midi-browser .entities .noresults {\n    color: var(--black-45);\n    font-style: italic;\n    height: 48px;\n    width: 100%;\n    font-size: 16px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-browser .entities .entity,\n.midi-browser .headers {\n    width: 100%;\n    height: 26px;\n\n    color: var(--black-65);\n    display: flex;\n    justify-content: left;\n    align-items: center;\n\n    user-select: none; \n}\n\n.midi-browser .entities .entity {\n    background-color: var(--black-00);\n}\n\n.midi-browser .headers {\n    height: 32px;\n    background-color: var(--black-10);\n}\n\n@keyframes midi-pulse-bg {\n    0%, 100% {\n        filter: opacity(1.0)\n    }\n    50% {\n        filter: opacity(0.5);\n    }\n}\n\n.midi-browser .entities .entity.learning {\n    animation: midi-pulse-bg 1s ease-in-out infinite;\n    background-color: rgba(147, 55, 255, 1);\n}\n\n.midi-browser .entities .entity:nth-child(odd):not(.learning) {\n    background-color: var(--black-02);\n}\n\n.midi-browser .entities .entity:nth-child(odd):not(.learning):hover, \n.midi-browser .entities .entity:hover {\n    color: var(--black-80);\n    background-color: var(--black-20);\n}\n\n.midi-browser .entities .entity .cat,\n.midi-browser .headers .header.cat {\n    width: 48px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.midi-browser .entities .entity .cat {\n    color: var(--black-45);\n}\n\n.midi-browser .entities .entity .cat .symbols {\n    font-size: 16px;\n}\n\n.midi-browser .entities .entity:hover .cat {\n    color: var(--black-80);\n}\n\n.midi-browser .entities .entity .name,\n.midi-browser .headers .header.name {\n    font-size: 14px;\n    flex-grow: 1;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.midi-browser .entities .entity .note,\n.midi-browser .headers .header.note {\n    position: relative;\n    width: 120px;\n    font-size: 12px;\n    flex-shrink: 0;\n\n    padding-left: 3px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-browser .entities .entity .note {\n    color: var(--black-80);\n}\n\n.midi-browser .entities .entity .note.shared:before {\n    position: absolute;\n    left: 5px;\n    content: '🟡';\n    font-size: 5px;\n}\n\n.midi-browser .entities .entity .actions {\n    width: 25px;\n    font-size: 18px;\n}\n\n.midi-browser > .header {\n    width: 320px;\n    margin-bottom: 4px;\n\n    font-size: 22px;\n\n    display: flex;\n    text-align: center;\n    justify-content:space-between;\n    align-items: center;\n}\n\n.midi-browser > .header > .left {\n    display: flex;\n    text-align: center;\n    justify-content: left;\n    align-items: center;\n    position: relative;\n}\n\n.midi-browser > .header > .right {\n    display: flex;\n    text-align: center;\n    justify-content: right;\n    align-items: center;\n}\n\n.midi-browser > .header .filter {\n    height: 26px;\n    width: 100px;\n    border-radius: 4px;\n\n    font-size: 13px;\n    font-weight: bold;\n    letter-spacing: 0;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    padding-left: 2px;\n\n    cursor: pointer;\n    user-select: none; \n\n    color: var(--black-05);\n    background-color: var(--black-65);\n}\n\n.midi-browser > .header .filter:hover {\n    background-color: var(--black-80);\n}\n\n.midi-browser > .header .note {\n    top: 5px;\n    left: 446px;\n    border-radius: 5px;\n    width: fit-content;\n    height: 26px;\n\n    font-size: 12px;\n    font-weight: bold;\n    letter-spacing: 0;\n    color: var(--black_10);\n    background-color: var(--black-65);\n\n    display: flex;\n    justify-content: left;\n    align-items: center;\n\n    padding-left: 5px;\n    padding-right: 7px;\n    padding-top: 1px;\n    margin-left: 10px;\n}\n\n.midi-browser > .header .note.disabled {\n    background-color: var(--black-25);\n    color: var(--black-15);\n}\n\n.midi-browser > .header .note::before {\n    content: 'music_note';\n    font-family: 'Material Symbols Outlined';\n    user-select: none;\n    font-weight: 500;\n    font-size: 14px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    color: var(--black-00);\n}\n\n.midi-browser > .header .note:hover::before {\n    content: 'close';\n}\n\n.midi-browser > .header .note:hover {\n    background-color: var(--black-80);\n}\n\n.midi-browser > .headers > .header {\n    width: 550px;\n}\n\n.midi-browser .headers .header.cat {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-browser .headers .header:hover  {\n    color: var(--black-90);\n}\n\n.midi-browser .headers .header {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    left: -8px;\n}\n\n.midi-browser .headers .header .order {\n    position: relative;\n    visibility: hidden;\n\n    left: 0px;\n\n    content: 'close';\n    font-family: 'Material Symbols Outlined';\n    user-select: none;\n    font-weight: 500;\n    font-size: 14px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-browser .headers .header.active {\n    color: var(--black-80);\n}\n\n.midi-browser .headers .header:hover .order {\n    visibility:visible;\n}\n\n.midi-browser .headers .header.active .order {\n    visibility:visible;\n}\n\n.midi-browser .headers .header .order.north:before {\n    content: 'north';\n}\n\n.midi-browser .headers .header .order.south:before {\n    content: 'south';\n}\n\n.midi-browser .headers .header .symbols {\n    font-size: 18px;\n}\n\n.midi-browser .headers .header.name {\n    font-weight: 500;\n    font-size: 14px;\n    width: 360px;\n    flex-grow: 0;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.midi-browser .headers .header.note {\n    font-size: 10px;\n    padding-left: 3px;\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
